import { useState, useEffect, useCallback } from "react";
import Chart from "chart.js";
import Header from "components/Headers/chatHeader.js";
import { CMM } from '../../Lib/Cmm.js';
import axios from 'axios';
import { auto, right } from '@popperjs/core';
import { chartOptions, parseOptions, } from "variables/charts.js";
import { GoChevronRight, GoChevronLeft } from "react-icons/go";
import icon_square from "../../assets/img/icons/common/icon_square.svg";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { ChromePicker } from 'react-color';
import { toast, ToastContainer } from 'react-toastify';
import { fetchAxios, postAxios, postNoauth, postWithFiles } from 'Lib/GetAxios';
import { etcStore } from 'store/etcStore';
import 'react-toastify/dist/ReactToastify.css';

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  ListGroup,
  ListGroupItem,
  Container,
  Row,
  Col,
  Input,
} from "reactstrap";


// const user_idx = sessionStorage.getItem('user_idx');
// const u_uuid = sessionStorage.getItem('u_uuid');

const ChatBot = (props) => {
  const [profile, setProfile] = useState(1);
  const [data, setDate] = useState([]);
  const [colorPicker, setColorPicker] = useState(false);

  const [name, setName] = useState('');
  const [info, setInfo] = useState('');
  const [salutation, setSalutation] = useState('');
  const [word, setWord] = useState('');
  const [link, setLink] = useState('');
  const [theme_color, setThemeColor] = useState('');
  const [text_color, setTextColor] = useState('');

  const [messages, setMessages] = useState([
    {
      text: '무엇을 도와드릴까요?',
      ownerType: "bot",
      chatType: 'T',
    },
    {
      text: '여기선 뭘 판매하나요?',
      ownerType: "user",
      chatType: 'T',
    },
    {
      text: 'ㅁㅁ사는 찰리와 초콜릿 공장에 등장하는 거대 풍선껌을 제작하고 판매하는 회사입니다.',
      ownerType: "bot",
      chatType: 'T',
    },
    {
      text: '여기선 뭘 판매하나요?',
      ownerType: "user",
      chatType: 'T',
    },
  ]);

  useEffect(() => {

    getProfile();

  }, [])

  //챗봇 프로필
  const getProfile = useCallback(() => {

    fetchAxios(`${CMM.SERVER_URL_API}/admin/chatbot_profile`,
      {})
      .then((res) => {
        if (res != 'ERROR') {
          // console.log(res);

          setDate(res[0]);

          const updatedMessages = [...messages];
          updatedMessages[0].text = res[0].salutation;
          setMessages(updatedMessages);

          setName(res[0].name);
          setInfo(res[0].info);
          setSalutation(res[0].salutation);
          setWord(res[0].word);
          setLink(res[0].link);
          setThemeColor(res[0].theme_color);
          setTextColor(res[0].text_color);

        }
      })
      .catch((e) => {
        console.log('error::', e.message)
      })
  }, [data, messages, name, info, salutation, word, link, theme_color, text_color]);



  //챗봇 이미지 업데이트
  // const imageEdit = useCallback(async (file, fileNm) => {

  //   if (!data || data.length == 0) return;

  //   let selectedFiles = [];

  //   if (fileNm) {
  //     selectedFiles.push({ "type": "0", "idx": "0", "file_nm": fileNm, "ori_file_nm": "", "gbn": "", "w": "0", "h": "0" })
  //   }

  //   const formData = new FormData();

  //   formData.append('cbp_idx', data.cbp_idx);
  //   formData.append('addfiles', JSON.stringify(selectedFiles));

  //   if (fileNm) {
  //     formData.append('fileup', file, fileNm);
  //   }

  //   axios({
  //     url: `${CMM.SERVER_URL_API}/admin/chatbot_profile_img`,
  //     method: 'POST',
  //     data: formData,
  //     headers: {
  //       'Accept': 'application/json',
  //       'Content-Type': 'multipart/form-data; ',
  //     }
  //   }).then((res) => {
  //     if (res != 'ERROR') {

  //       getProfile();
  //     }
  //   })
  //     .catch((e) => {
  //       console.log('error', e);
  //       return 'ERROR';
  //     })

  // }, [data])

  const imageEdit = useCallback(async (file, fileNm) => {


    if (!data || data.length == 0) return;

    let selectedFiles = [];

    if (fileNm) {
      selectedFiles.push({ "type": "0", "idx": "0", "file_nm": fileNm, "ori_file_nm": "", "gbn": "", "w": "0", "h": "0" })
    }

    let addfiles = [];
    if (fileNm) {
      addfiles.push({
        uri: file,
        name: fileNm
      })
    }

    const res = await postWithFiles(`${CMM.SERVER_URL_API}/admin/chatbot_profile_img`, {
      addfiles: JSON.stringify(selectedFiles),
      cbp_idx: data.cbp_idx,
    },
      addfiles
    ).then(async (res) => {
      if (res != 'ERROR') {
        getProfile();

      } else {
        console.log('error ::', res)
        alert('등록 실패.');
      }

    }).catch((e) => {
      console.log('error :: ', e.message);
    });

  }, [data]);

  // 파일선택
  const changeFileHandler = useCallback((e) => {
    e.preventDefault();

    if (!e.target.files) return;
    if (!e.target.files[0]) return;

    const file = e.target.files[0];

    console.log('filehandler::', file);

    imageEdit(file, file.name);

  }, [data]);


  //챗봇 프로필 업데이트
  const profileEdit = useCallback(async () => {

    //기존 분류 답변 수정
    const res = await postAxios(`${CMM.SERVER_URL_API}/admin/chatbot_profile_edit`,
      {
        cbp_idx: data.cbp_idx,
        info: info,
        salutation: salutation,
        word: word,
        link: link,
        theme_color: theme_color,
        text_color: text_color,
        name: name,
      })
      .then((res) => {
        if (res != 'ERROR') {
          //토스트 메시지
          toast.success('성공적으로 변경되었습니다.', {
            position: "bottom-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
          });

          getProfile();
        }
      })
      .catch((e) => {
        console.log('error::', e.message);
      })

  }, [data, info, salutation, word, link, theme_color, text_color, name]);

  // 채팅 보이는 조건
  const renderMessageText = (index, messages) => {
    const message = messages[index];

    //메시지 타입이 링크일 경우
    if (message.chatType == 'L') {
      //대체 텍스트 없으면 그냥 url
      return <a href={message.text} target="_blank">{message.linkText ? message.linkText : message.text}</a>;
    }
    //메시지 타입이 일반 텍스트일 경우
    else {

      return message.text;
    }

  };


  if (window.Chart) {
    parseOptions(Chart, chartOptions());
  }

  return (
    <>
      <Header />
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />
      {/* Page content */}
      <Container className="mt--7 position-absolute start-0" fluid style={{ maxWidth: '1300px', }}>
        <Card className="bg-white">
          <CardHeader className="bg-white">
            <div className="font-weight-bold d-none d-sm-block"
              style={{ lineHeight: 1.2 }}>
              <h1 className="d-inline-block"
                style={{ color: 'black' }}>
                챗봇 관리</h1>
              {/* <div className=""
                style={{ color: '#727272' }}>
                고객의 질문에 대응하는 답변을 입력하고 관리할 수 있습니다.
              </div>
              <div className=""
                style={{ color: '#727272' }}>
                상품 소개, 문의하기 등 링크를 달아 더 많은 정보를 제공할 수 있습니다.
              </div> */}
            </div>
            <div className="font-weight-bold d-sm-none "
              style={{ lineHeight: 1.2 }}>
              <h2 className="d-inline-block"
                style={{ color: 'black' }}>
                챗봇 관리</h2>
              {/* <div className="   "
                style={{ color: '#727272', fontSize: '14px' }}>
                고객의 질문에 대응하는 답변을 입력하고 관리할 수 있습니다.
              </div>
              <div className=" "
                style={{ color: '#727272', fontSize: '14px' }}>
                상품 소개, 문의하기 등 링크를 달아 더 많은 정보를 제공할 수 있습니다.
              </div> */}
            </div>
          </CardHeader>
          {(data && data.cbp_idx != '') &&
            <CardBody className="p-0 bg-white ">
              <Row className=" px-3">
                <Col className="mb-xl-0 p-0" xl="6">
                  <Card className="">
                    <CardHeader className="" style={{ height: '50', overflowY: 'auto' }} >
                      <Row className="align-items-center">
                        <div className="col d-flex align-items-center">
                          <h3 className="mb-0">챗봇 프로필</h3>
                          <div className="ml-auto">
                            <button
                              className="btn btn-sm text-break ml-2 mr-2 shadow-none border-0 bg-white d-inline"
                              onClick={(e) => {
                                e.preventDefault();
                                setProfile(1);
                              }}
                            >
                              <GoChevronLeft />
                            </button>
                            <span className="text-sm">{profile}/2</span>
                            <button
                              className="btn btn-sm text-break ml-2 mr-2 shadow-none border-0 bg-white d-inline"
                              onClick={(e) => {
                                e.preventDefault();
                                setProfile(2);
                              }}
                            >
                              <GoChevronRight />
                            </button>
                          </div>
                        </div>

                      </Row>
                    </CardHeader>
                    <CardBody className='p-0' style={{ height: '55vh', overflowY: 'auto', maxHeight: '580px' }}>
                      {
                        profile == 1 ?
                          <div>
                            <Container className="pt-2">
                              <Col lg="12" className="">
                                <label className="form-control-label text-dark "
                                  style={{ fontSize: '17px' }}>
                                  로고
                                  <span
                                    className="cursor-pointer opacity-0"
                                  >
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-1 ml-1">
                                      <path d="M6 0C2.688 0 0 2.688 0 6C0 9.312 2.688 12 6 12C9.312 12 12 9.312 12 6C12 2.688 9.312 0 6 0ZM6.6 10.2H5.4V9H6.6V10.2ZM7.842 5.55L7.302 6.102C6.87 6.54 6.6 6.9 6.6 7.8H5.4V7.5C5.4 6.84 5.67 6.24 6.102 5.802L6.846 5.046C7.068 4.83 7.2 4.53 7.2 4.2C7.2 3.54 6.66 3 6 3C5.34 3 4.8 3.54 4.8 4.2H3.6C3.6 2.874 4.674 1.8 6 1.8C7.326 1.8 8.4 2.874 8.4 4.2C8.4 4.728 8.184 5.208 7.842 5.55Z" fill="#D9D9D9" />
                                    </svg>
                                  </span>
                                  <span className="form-control-label text-sm ml-1 text-black-50">고객에게 보여지는 채팅 프로필 이미지 입니다.</span>
                                </label>
                              </Col>
                              <Col lg="5" className="">
                                <div className="text-left ml-2">
                                  <label className="relative cursor-pointer text-center">
                                    <input
                                      id="dropzone-file-1"
                                      type="file"
                                      className="position-absolute inset-0 h-full opacity-0 z-10 sr-only"
                                      onChange={(e) => {
                                        changeFileHandler(e);
                                      }}
                                    />
                                    <img
                                      src={`${CMM.SERVER_URL_API}/files/${data.image}`}
                                      style={{ width: '150', height: '150px' }}
                                      className=" object-cover block rounded-lg"
                                    />
                                  </label>
                                </div>
                              </Col>
                              <Col lg="12" className="">
                                <label className="form-control-label text-dark "
                                  style={{ fontSize: '17px' }}>
                                  챗봇 이름
                                </label>
                              </Col>
                              <Col lg="8" className="pl-4">
                                <Input
                                  className="form-control-alternative mb-2 border shadow-none text-dark"
                                  value={name}
                                  placeholder=""
                                  onChange={(e) => {
                                    setName(e.target.value);
                                  }}
                                />
                              </Col>
                              <div className="pt-3">
                                <Col lg="12">
                                  <label className="form-control-label text-dark "
                                    style={{ fontSize: '17px' }}>
                                    소개 문구 ({info.length}/30)
                                  </label>
                                  <span
                                    className="cursor-pointer opacity-0"
                                  >
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-1 ml-1">
                                      <path d="M6 0C2.688 0 0 2.688 0 6C0 9.312 2.688 12 6 12C9.312 12 12 9.312 12 6C12 2.688 9.312 0 6 0ZM6.6 10.2H5.4V9H6.6V10.2ZM7.842 5.55L7.302 6.102C6.87 6.54 6.6 6.9 6.6 7.8H5.4V7.5C5.4 6.84 5.67 6.24 6.102 5.802L6.846 5.046C7.068 4.83 7.2 4.53 7.2 4.2C7.2 3.54 6.66 3 6 3C5.34 3 4.8 3.54 4.8 4.2H3.6C3.6 2.874 4.674 1.8 6 1.8C7.326 1.8 8.4 2.874 8.4 4.2C8.4 4.728 8.184 5.208 7.842 5.55Z" fill="#D9D9D9" />
                                    </svg>
                                  </span>
                                  <span className="form-control-label text-md ml-1 text-black-50">회사소개에 대한 짧은 소개글을 작성해주세요.</span>
                                </Col>
                                <Col lg="8" className="pl-4">
                                  <Input
                                    type="textarea"
                                    style={{ height: '100px' }}
                                    maxLength={30}
                                    className="form-control-alternative mb-2 border shadow-none text-dark"
                                    value={info}
                                    onChange={(e) => {
                                      setInfo(e.target.value);
                                    }}
                                  />
                                </Col>
                              </div>
                            </Container>
                            <Col className="text-right mt-3" xs="12">
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  profileEdit();
                                }}
                                className="btn text-center pl-2 pr-2 pt-1 pb-1 text-white ml-4"
                                style={{ backgroundColor: '#3094FF', fontWeight: 'normal' }}>
                                저장
                              </button>
                            </Col>
                          </div>
                          :
                          <div>
                            <Container className="pt-2">
                              <Col lg="12" className="">
                                <label className="form-control-label text-dark "
                                  style={{ fontSize: '17px' }}>
                                  인사말
                                </label>
                                <span
                                  className="cursor-pointer opacity-0"
                                >
                                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-1 ml-1">
                                    <path d="M6 0C2.688 0 0 2.688 0 6C0 9.312 2.688 12 6 12C9.312 12 12 9.312 12 6C12 2.688 9.312 0 6 0ZM6.6 10.2H5.4V9H6.6V10.2ZM7.842 5.55L7.302 6.102C6.87 6.54 6.6 6.9 6.6 7.8H5.4V7.5C5.4 6.84 5.67 6.24 6.102 5.802L6.846 5.046C7.068 4.83 7.2 4.53 7.2 4.2C7.2 3.54 6.66 3 6 3C5.34 3 4.8 3.54 4.8 4.2H3.6C3.6 2.874 4.674 1.8 6 1.8C7.326 1.8 8.4 2.874 8.4 4.2C8.4 4.728 8.184 5.208 7.842 5.55Z" fill="#D9D9D9" />
                                  </svg>
                                </span>
                                <span className="form-control-label text-md ml-1 text-black-50">대화를 시작할 때 고객에게 건네는 인사말입니다.</span>
                              </Col>
                              <Col lg="8" className="pl-4">
                                <Input
                                  className="form-control-alternative mb-2 border shadow-none text-dark"
                                  value={salutation}
                                  placeholder=""
                                  onChange={(e) => {
                                    setSalutation(e.target.value);
                                  }}
                                />
                              </Col>
                              <Col lg="12" className="">
                                <label className="form-control-label text-dark "
                                  style={{ fontSize: '17px' }}>
                                  기본 응답 문구
                                </label>
                                <span
                                  className="cursor-pointer opacity-0"
                                >
                                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" className="mb-1 ml-1">
                                    <path d="M6 0C2.688 0 0 2.688 0 6C0 9.312 2.688 12 6 12C9.312 12 12 9.312 12 6C12 2.688 9.312 0 6 0ZM6.6 10.2H5.4V9H6.6V10.2ZM7.842 5.55L7.302 6.102C6.87 6.54 6.6 6.9 6.6 7.8H5.4V7.5C5.4 6.84 5.67 6.24 6.102 5.802L6.846 5.046C7.068 4.83 7.2 4.53 7.2 4.2C7.2 3.54 6.66 3 6 3C5.34 3 4.8 3.54 4.8 4.2H3.6C3.6 2.874 4.674 1.8 6 1.8C7.326 1.8 8.4 2.874 8.4 4.2C8.4 4.728 8.184 5.208 7.842 5.55Z" fill="#D9D9D9" />
                                  </svg>
                                </span>
                                <span className="form-control-label text-md ml-1 text-black-50">챗봇이 적절한 답변을 찾지 못했을 때 고객에게 전송되는 대체 텍스트입니다.</span>
                              </Col>
                              <Col lg="8" className="pl-4">
                                <Input
                                  className="form-control-alternative mb-2 border shadow-none text-dark"
                                  value={word}
                                  placeholder=""
                                  onChange={(e) => {
                                    setWord(e.target.value);
                                  }}
                                />
                              </Col>
                              <Col lg="8" className="pl-4">
                                <Input
                                  className="form-control-alternative mb-2 border shadow-none text-dark"
                                  value={link}
                                  placeholder="https://"
                                  onChange={(e) => {
                                    setLink(e.target.value);
                                  }}
                                />
                              </Col>
                              <Col lg="12" className="">
                                <label className="form-control-label text-dark "
                                  style={{ fontSize: '17px' }}>
                                  테마 색상
                                </label>
                                <span
                                  onClick={(e) => {
                                    e.preventDefault();
                                    window.alert('크릭하');
                                  }}
                                  className="cursor-pointer opacity-0"
                                >
                                </span>
                              </Col>
                              <Col lg="8" className="pl-4">
                                <div className="d-flex align-items-left">
                                  <div className="rounded-lg mr-4"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setColorPicker(!colorPicker);
                                    }}
                                    style={{ backgroundColor: theme_color, width: '50px', height: '40px' }}>
                                  </div>
                                  <Input
                                    className="form-control-alternative mb-2 border shadow-none text-dark"
                                    value={theme_color}
                                  />
                                </div>
                                {
                                  colorPicker ?
                                    <ChromePicker
                                      color={theme_color}
                                      onChange={(color) => setThemeColor(color.hex)}
                                    /> : ''
                                }
                              </Col>
                              <Col lg="12" className="">
                                <label className="form-control-label text-dark "
                                  style={{ fontSize: '17px' }}>
                                  텍스트 색상
                                </label>
                              </Col>
                              <Col lg="8" className="pl-4">
                                <div className="d-flex align-items-left">
                                  <div className="rounded-lg mr-2 bg-dark mr-4"
                                    style={{ width: '40px', height: '40px' }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setTextColor('#000000');
                                    }}>
                                  </div>
                                  <div className="rounded-lg mr-2 bg-white  border border-dark "
                                    style={{ width: '40px', height: '40px' }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setTextColor('#FFFFFF');
                                    }}>
                                  </div>
                                </div>

                              </Col>
                            </Container>
                            <Col className="text-right mt-3" xs="12">
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  profileEdit();
                                }}
                                className="btn text-center pl-2 pr-2 pt-1 pb-1 text-white ml-4"
                                style={{ backgroundColor: '#3094FF', fontWeight: 'normal' }}>
                                저장
                              </button>
                            </Col>

                          </div>
                      }
                    </CardBody>

                  </Card>
                </Col>
                <Col xl="6" className="p-0">
                  <Card className="" >
                    <CardHeader className="bg-transparent" style={{ height: '50', overflowY: 'auto' }} >
                      <Row className="align-items-center">
                        <div className="col">
                          <h3 className="mb-0">챗봇 예시</h3>
                        </div>
                      </Row>
                    </CardHeader>
                    <CardBody className='p-0 ' style={{ height: '55vh', overflowY: 'auto', maxHeight: '580px' }}>
                      <style>
                        {`
                    /* Chrome 및 Safari 스크롤바 숨기기 */
                    ::-webkit-scrollbar {
                      width: 0 !important; /* 스크롤바 너비를 0으로 설정하여 숨깁니다. */
                    }
                  `}
                      </style>
                      <div className="container mt-1 text_div no-scrollbars py-3 "
                        style={{ width: '350px', height: '500px' }}>
                        {

                          profile == 1 ?
                            <div>
                              <div className="pb-5 rounded-lg " style={{ backgroundColor: '#FCFBFB', border: '1px solid rgba(189, 189, 189, 0.5)' }}>
                                <span
                                  className="px-4 py-4"
                                  style={{ fontWeight: 'bold', color: '#000000', fontSize: '24px', display: 'block' }}
                                >{data.comp_nm}</span>
                                <div className="text-center">
                                  <Card className="bg-secondary shadow mx-3 bg-white" style={{ borderRadius: '20px' }}>
                                    <CardHeader className=" border-0" style={{ borderRadius: '20px' }}>
                                      <Row className="align-items-center">
                                        <img
                                          className=""
                                          style={{ borderRadius: '20px' }}
                                          src={`${CMM.SERVER_URL_API}/files/${data.image}`} width="55" height="55" alt="박대리" />
                                        <span
                                          className="px-2"
                                          style={{ fontWeight: 'bold', color: '#000000', fontSize: '16px', display: 'block' }}
                                        >{name}</span>
                                      </Row>
                                      <span
                                        className="py-4 px-4"
                                        style={{ color: '#000000', fontSize: '16px', display: 'block' }}
                                      >{data.info}</span>
                                      <Button
                                        style={{ backgroundColor: theme_color, color: 'white', border: 'none' }}
                                        className="px-6"
                                      >
                                        <span style={{ marginLeft: "5px" }}>문의하기</span>
                                        <FontAwesomeIcon icon={faPaperPlane} />
                                      </Button>
                                    </CardHeader>
                                  </Card>
                                  <span
                                    className="py-2 pb-5"
                                    style={{ fontWeight: 'bold', color: '#777777', fontSize: '12px', display: 'block' }}
                                  >박대리 채용하기</span>
                                </div>
                              </div >
                              <div className="container mt-3">
                                <div className="input-group">
                                  <div className="input-group-append">
                                  </div>
                                </div>
                              </div>
                            </div>
                            :
                            <div>
                              <div className="  rounded-lg bg-white" style={{ backgroundColor: '#FCFBFB', border: '1px solid rgba(189, 189, 189, 0.5)' }}>
                                <div className="container mt-1 text_div bg-white mb-1" style={{ paddingTop: 5 }}>
                                  <div>
                                    <div>
                                      <Link to="/chatbot/Chat" style={{ color: '#777777', paddingLeft: 5 }}>
                                        <FontAwesomeIcon icon={faAngleLeft} className='' />
                                      </Link>
                                    </div>
                                    {messages.map((message, index) => (
                                      <div className={message.ownerType === 'user' ? "row align-items-center my-3" : "row align-items-center my-3"}
                                        style={message.ownerType === 'user' ? { textAlign: right, marginLeft: auto } : {}}
                                      >
                                        <div className={message.ownerType === 'user' ? "d-none" : "col-auto px-2 align-self-start"} >
                                          <img
                                            className='rounded-pill '
                                            src={`${CMM.SERVER_URL_API}/files/${data.image}`}
                                            width="33"
                                            height="33"
                                          />
                                        </div>
                                        <div className={message.ownerType === 'user' ? "col px-2" : "col p-0"}>
                                          <div className="rounded p-2 d-inline-block m-0 "
                                            style={{
                                              maxWidth: '70%',
                                              backgroundColor: message.ownerType === "user" ? theme_color : '#E6E6E6',
                                              color: message.ownerType === "user" ? text_color : '#000000',
                                              textAlign: message.ownerType === "user" ? 'left' : ''
                                            }}>
                                            {renderMessageText(index, messages)}
                                          </div>
                                          <div style={{ fontSize: '13px' }}>오전 10:22</div>
                                        </div>
                                      </div>
                                    ))
                                    }
                                  </div>
                                </div >

                                <div className="px-2">
                                  <Input
                                    className="form-control-alternative mb-2 border shadow-none text-dark"
                                    placeholder="메시지를 입력하세요"
                                  // onChange={(e) => {
                                  //   setNewUrl(e.target.value);
                                  // }}
                                  />
                                </div>
                              </div >
                            </div>
                        }
                      </div>

                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </CardBody>
          }
        </Card>
      </Container >
    </>
  );
};

export default ChatBot;
